import React from 'react';
import authTokenService from 'common/authTokenService';
import './TroubleshootingApp.scss';
import { parseJwt } from './jwtHelper';
import Header from './Header';


const TroubleshootingApp: React.FC = () => {

    return <div className="container-fluid troubleshooting-app">
        <Header />
        <h2>Troubleshooting</h2>

        <p>
            The following data may be helpful for the support team to assist in any issues with the site.
        </p>

        <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3">
            <BrowserInformation />

            <ConnectionInformation />
            <AuthInformation />
        </div>

    </div>;
}


const BrowserInformation: React.FC = React.memo(() => {
    // TS does not yet include types for this non-baseline feature
    const nav = globalThis.navigator as unknown as Navigator & {
        userAgentData?: { platform: string;
            mobile: boolean;
            brands: { brand: string; version: string }[];
        }
    };
    const ua = nav.userAgentData;

    return <DataGroup header="Browser Info">
        <DataPoint label="Current time" value={new Date().toString()} />
        <DataPoint label="Platform" value={ua?.platform} />
        <DataPoint label="Mobile" value={ua?.mobile != null && (ua.mobile ? "true" : "false")} />
        <DataPoint label="Brands" value={ua?.brands?.map((m) => `${m.brand} ${m.version}`).join(', ')} />
        <DataPoint label="Raw User Agent" value={nav.userAgent} />
        <DataPoint label="Language" value={nav.language} />
    </DataGroup>;
})


const ConnectionInformation: React.FC = React.memo(() => {
    // TS does not yet include types for this non-baseline feature
    const connection = (globalThis.navigator as unknown as Navigator & {
        connection?: {
            type: string;
            effectiveType: string;
            downlink: number;
            rtt: number;
        }
    }).connection;

    if (connection == null) return null;

    return <DataGroup header="Connection">
        <DataPoint label="Type" value={connection.type} />
        <DataPoint label="Effective Type" value={connection.effectiveType} />
        <DataPoint label="Downlink" value={connection.downlink} />
        <DataPoint label="RTT" value={connection.rtt} />
    </DataGroup>;
})


const AuthInformation: React.FC = React.memo(() => {

    const token = authTokenService.getToken();

    const tokenObj = parseJwt(token);

    function formatUnixTimestamp(val: number): string {
        return new Date(val * 1000).toString();
    }

    return <DataGroup header="Authentication">
        {token == null && <p>User is <strong>not</strong> logged in</p>}
        {tokenObj != null && <>
            <DataPoint label="First Name" value={tokenObj.FirstNameClaim} />
            <DataPoint label="Last Name" value={tokenObj.LastNameClaim} />
            <DataPoint label="Email" value={tokenObj.EmailClaim} />
            <DataPoint label="Federation ID" value={tokenObj.IdentityId} />
            <DataPoint label="Auth Time" value={tokenObj.auth_time}
                formatter={formatUnixTimestamp} />
            <DataPoint label="Expire Time" value={tokenObj.exp}
                formatter={formatUnixTimestamp} />
        </>}
    </DataGroup>
})

interface DataGroupProps {
    header: string
}

const DataGroup: React.FC<DataGroupProps> = React.memo(props => {
    return <div className="col mb-4">
        <div className="card">
            <div className="card-header">{props.header}</div>
            <div className="card-body">
                {props.children}
            </div>
        </div>
    </div>
})

interface DataPointProps {
    label: string;
    value: string | number;
    formatter?(val: string | number): string;
}

const DataPoint: React.FC<DataPointProps> = React.memo(props => {
    if (props.value == null) return <></>;

    return <div className="data-point row">
        <div className="col-* col-lg-3 label">{props.label}</div>
        <div className="col">{props.formatter == null
            ? props.value
            : props.formatter(props.value)}</div>
    </div>
});

export default TroubleshootingApp;
